import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { GiftCardTransactionFragment } from '@/gql/generated';
import { formatDateToTimezone } from '@/lib/timezone';
import { formatNumberToCurrency } from '@/lib/utils';
import { GiftCardTransactionType } from '@/types/gift-card-check-code/graphql/type-gift-card.constant';
import clsx from 'clsx';

const TableMobile = ({
  transactions,
  timeZone,
}: {
  transactions: GiftCardTransactionFragment[];
  timeZone: string;
}) => {
  return (
    <div>
      <Table>
        <TableBody>
          {transactions?.map((transaction, index) => (
            <TableRow key={transaction.dts_order_id}>
              <TableCell>
                <div className="flex flex-col gap-2">
                  <div className="flex flex-row">
                    <div className="w-full text-left">NO.</div>
                    <div className="w-full text-right">{index + 1}</div>
                  </div>
                  <div className="flex flex-row">
                    <div className="w-full text-left">Order Id</div>
                    <div className="w-full text-right">
                      {transaction.dts_order_id}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="w-full text-left">Transaction</div>
                    <div className="w-full text-right">
                      <div
                        className={clsx(
                          'font-bold',
                          transaction.type === GiftCardTransactionType.TOP_UP
                            ? 'text-[#13BC8E]'
                            : '',
                        )}
                      >
                        {transaction.type === GiftCardTransactionType.TOP_UP
                          ? '+'
                          : '-'}
                        {formatNumberToCurrency(transaction.balance_change)}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="text-left">Balance</div>
                    <div className="w-full text-right font-bold">
                      {formatNumberToCurrency(transaction.balance_after)}
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="flex-none text-left">Date</div>
                    <div className="w-full text-right">
                      {transaction.date
                        ? formatDateToTimezone(
                            transaction.date,
                            timeZone,
                            'LLL d, yyyy hh:mm a',
                          )
                        : ''}
                    </div>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TableMobile;
